<template>
  <div class="dnd-invoices">
    <div class="dnd-invoices__header">DND invoices</div>
    <div class="dnd-invoices__actions">
      <text-input
        v-model="searchTerm"
        class="dnd-invoices__actions__input"
        :show-clear-btn="true"
        :value="searchTerm"
        placeholder="Provide a search term"
        icon="magnifying-glass"
        icon-position="left"
        @onChange="onSearch" />
      <Button
        label="Configure Columns"
        appearance="tertiary"
        icon="sliders-horizontal"
        icon-position="left"
        @onClick="openConfigureModal" />
    </div>
    <div class="dnd-invoices__table">
      <Table
        :default-columns="dndInvoiceColumns"
        :row-data="dndRowData"
        primary-key="tp_doc_number"
        header-cell-background="#f7f7f7"
        no-data-message="DND Invoice data is not available">
        <template #default="{ row, col }">
          <span
            v-tooltip="getTableCellValueToolip(row, col)"
            class="table-cell">
            {{ getTableCellValue(row, col) }}
          </span>
        </template>
      </Table>
    </div>
    <configure-modal
      v-if="configModalIsOpen"
      :default-columns="dndInvoiceColumns"
      :config-columns="dndInvoiceColumns"
      :local-storage-name="cacheNames.dndTableConfig"
      @onModalClose="onModalClose"
      @saveColumnConfig="saveColumnConfig" />
  </div>
</template>

<script>
import ConfigureModal from "@/components/ConfigureListViewModal/ConfigureListViewModal.vue";

import { dndInvoiceColumns, dndData } from "@/config/dndConstant.js";

import { cacheNames } from "@/config/constant.js";

import { format } from "date-fns";

export default {
  name: "DndInvoices",
  components: {
    ConfigureModal,
  },
  props: {
    ohpDisputeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dndInvoiceColumns,
      configModalIsOpen: false,
      dndData,
      cacheNames,
    };
  },
  computed: {
    dndRowData() {
      return dndData[this.ohpDisputeId].map((item) => ({
        ...item.dndEntity,
        ...item.cxedDataEntity,
      }));
    },
  },
  methods: {
    openConfigureModal() {
      this.configModalIsOpen = true;
    },
    onModalClose() {
      this.configModalIsOpen = false;
    },
    getTableCellValue(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
      }
      return !value || typeof value === "undefined" || value === "null"
        ? "-"
        : value;
    },
    getTableCellValueToolip(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
      } else {
        return value;
      }
    },
    async saveColumnConfig(config) {
      this.dndInvoiceColumns = config;
    },
  },
};
</script>

<style lang="scss" scoped>
.dnd-invoices {
  &__header {
    font-weight: 600;
    margin-bottom: 16px;
  }
  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__input {
      flex: 1;
      margin-right: 16px;
    }
  }
  &__table {
    overflow: auto;
    margin-top: 16px;
  }
}
</style>
